import { txtClaimGoldPopupButton, txtClaimGoldPopupSubtitle, txtClaimGoldPopupTitle } from "../../../../../constants/texts";
import { IPopupContentTexts } from "../../../../../state/popup-state";

export const generateClaimGoldPopupTexts = (): IPopupContentTexts => ({
    titleTxt: txtClaimGoldPopupTitle,
    subtitleTxt: txtClaimGoldPopupSubtitle,
    actionNameTxt: txtClaimGoldPopupButton
});